module.exports = __webpack_public_path__ + "static/media/Paw3_o_2c.9e43ed8f.svg";